import { render, staticRenderFns } from "./GradeSettings.vue?vue&type=template&id=b177742a&"
import script from "./GradeSettings.vue?vue&type=script&lang=js&"
export * from "./GradeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports